import React from 'react';
import { Paper, Typography, Grid, Divider } from '@mui/material';
import { FormatDateTimeString } from '../../utils/helper';
import { User } from '../../services/inventory/types';

interface AuditInformationProps {
  createdByUser?: User;
  createdByUserId?: number;
  modifiedByUser?: User;
  modifiedByUserId?: number;
  created: Date;
  modified: Date;
}

const AuditInformation: React.FC<AuditInformationProps> = ({
  createdByUser,
  createdByUserId,
  modifiedByUser,
  modifiedByUserId,
  created,
  modified,
}) => {
  const getUserDisplay = (user?: User, userId?: number) => {
    if (user) {
      return user.name ? `${user.name} (${user.email})` : user.email;
    }
    return `User ${userId}`;
  };

  return (
    <Paper elevation={1} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Audit Information
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="text.secondary">
            Created By
          </Typography>
          <Typography variant="body2">{getUserDisplay(createdByUser, createdByUserId)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="text.secondary">
            Created On
          </Typography>
          <Typography variant="body2">{FormatDateTimeString(created)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="text.secondary">
            Last Modified
          </Typography>
          <Typography variant="body2">{FormatDateTimeString(modified)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="text.secondary">
            Modified By
          </Typography>
          <Typography variant="body2">
            {getUserDisplay(modifiedByUser, modifiedByUserId)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AuditInformation;
